import { fromEntries } from "../fromEntries";

let metadata;

/**
 * Get the contents of meta tags
 */
export const pageMetaData = (): {
    browser_stats_api: string;
    browser_relay_service_api: string;
    pagename: string;
    user_id: string;
    ctx_id: string;
    uid: string;
    is_bot: boolean;
} => (metadata = metadata || readMetaData());

function readMetaData(): Record<string, any> {
    const metaContent = fromEntries(
        Array.from(document.querySelectorAll("meta[name][content]")).map(
            (element) => [
                element.getAttribute("name"),
                element.getAttribute("content"),
            ],
        ),
    );

    return fromEntries(
        [
            ["browser_stats_api", metaContent.browser_stats_api_v1],
            [
                "browser_relay_service_api",
                metaContent.browser_relay_service_api,
            ],
            [
                "pagename",
                metaContent["fiverrmeta:performance_monitor_pagename"],
            ],
            ["user_id", metaContent.user_id],
            ["ctx_id", metaContent.ctx_id],
            ["uid", metaContent.u_guid],
            [
                "is_bot",
                typeof metaContent["fiverrmeta:is_known_crawler"] === "string"
                    ? metaContent["fiverrmeta:is_known_crawler"] === "true"
                    : undefined,
            ],
        ].filter(([, value]) => typeof value !== "undefined"),
    );
}
